(function () {
  const menuToggle = document.querySelector('[data-tie-menu-toggle]');
  const mobileMenu = document.querySelector('[data-tie-mobile-menu]');
  const header = document.querySelector('.tie-header');
  const body = document.body;
  const sideCart = document.querySelector('[data-tie-side-cart]');
  const sideCartPanel = sideCart ? sideCart.querySelector('.tie-side-cart__panel') : null;
  const sideCartBody = sideCart ? sideCart.querySelector('[data-tie-side-cart-body]') : null;
  const sideCartFooter = sideCart ? sideCart.querySelector('[data-tie-side-cart-footer]') : null;
  const sideCartUpsellScript = sideCart ? sideCart.querySelector('[data-tie-side-cart-upsells]') : null;
  const searchModal = document.querySelector('[data-tie-search-modal]');
  const searchInput = searchModal ? searchModal.querySelector('[data-tie-search-input]') : null;
  const fallbackCartImage = sideCartBody?.dataset.tieCartFallbackImage || '';
  const sideCartUpsellHeading = sideCart?.dataset.tieSideCartUpsellHeading || 'Bestsellers to pair with it';
  let sideCartUpsells = [];

  if (sideCartUpsellScript) {
    try {
      sideCartUpsells = JSON.parse(sideCartUpsellScript.textContent || '[]');
    } catch (error) {
      sideCartUpsells = [];
    }
  }

  const formatRupees = (value) => {
    const amount = Number(value || 0);
    const hasPaise = Math.round(amount * 100) % 100 !== 0;
    return `₹${amount.toLocaleString('en-IN', {
      minimumFractionDigits: hasPaise ? 2 : 0,
      maximumFractionDigits: hasPaise ? 2 : 0,
    })}`;
  };

  const formatMoney = (cents) => formatRupees(Number(cents || 0) / 100);

  const parseMoneyAmount = (value) => {
    const amount = Number(String(value || '').replace(/[^\d.-]/g, ''));
    return Number.isFinite(amount) ? amount : null;
  };

  const setConvertibleMoney = (element, text, amount = parseMoneyAmount(text)) => {
    if (!element) return;

    element.textContent = text;

    if (amount === null) {
      element.removeAttribute('data-price');
    } else {
      element.dataset.price = String(amount);
    }

    element.removeAttribute('data-current-currency-code');
    element.classList.remove('conversion_done');
  };

  const normalizeMoneyText = (value) => String(value || '').replace(
    /(?:INR|Rs\.?|₹)\s*([\d,]+(?:\.\d{1,2})?)/gi,
    (match, amount) => formatRupees(Number(String(amount).replace(/,/g, '')))
  );

  const normalizeMoneyElements = (root = document) => {
    const elements = [];
    if (root instanceof Element && root.matches('.money')) elements.push(root);
    if (root.querySelectorAll) elements.push(...root.querySelectorAll('.money'));

    elements.forEach((element) => {
      const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
      let node = walker.nextNode();

      while (node) {
        const normalized = normalizeMoneyText(node.nodeValue);
        if (normalized !== node.nodeValue) node.nodeValue = normalized;
        node = walker.nextNode();
      }
    });
  };

  normalizeMoneyElements();

  const moneyObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'characterData') {
        const moneyElement = mutation.target.parentElement?.closest('.money');
        if (moneyElement) normalizeMoneyElements(moneyElement);
        return;
      }

      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) normalizeMoneyElements(node);
      });
    });
  });

  moneyObserver.observe(document.body, { childList: true, subtree: true, characterData: true });

  const escapeHtml = (value) => String(value || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');

  const setupReadMoreCards = () => {
    document.querySelectorAll('[data-tie-read-more]').forEach((button) => {
      if (button.dataset.tieReadMoreReady === 'true') return;
      const container = button.closest('[data-tie-read-more-wrap]') || button.closest('.tie-review-card');
      const copy = container ? container.querySelector('[data-tie-read-more-copy]') : null;
      if (!container || !copy) return;

      const sync = () => {
        const isExpanded = container.classList.contains('is-expanded');
        if (isExpanded) {
          container.classList.add('has-read-more');
          return;
        }

        container.classList.toggle('has-read-more', copy.scrollHeight > copy.clientHeight + 2);
      };

      button.dataset.tieReadMoreReady = 'true';
      button.addEventListener('click', () => {
        const expanded = !container.classList.contains('is-expanded');
        container.classList.toggle('is-expanded', expanded);
        button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        button.textContent = expanded ? 'Read less' : 'Read more';
        sync();
      });

      requestAnimationFrame(sync);
      window.addEventListener('resize', sync, { passive: true });
    });
  };

  const openSideCart = () => {
    if (!sideCart) return;
    sideCart.classList.add('is-open');
    sideCart.setAttribute('aria-hidden', 'false');
    body.classList.add('tie-body-lock');
    window.requestAnimationFrame(() => {
      if (sideCartBody) sideCartBody.scrollTop = 0;
      if (sideCartPanel) sideCartPanel.scrollTop = 0;
    });
  };

  const closeSideCart = () => {
    if (!sideCart) return;
    sideCart.classList.remove('is-open');
    sideCart.setAttribute('aria-hidden', 'true');
    body.classList.remove('tie-body-lock');
  };

  const updateCartCount = (count) => {
    document.querySelectorAll('[data-tie-cart-count]').forEach((node) => {
      node.textContent = String(count);
    });
  };

  const bagIconMarkup = '<svg aria-hidden="true" focusable="false" viewBox="0 0 24 24"><path d="M6.5 8.5h11l1.1 12h-13L6.5 8.5Z"></path><path d="M9 8.5V7a3 3 0 0 1 6 0v1.5"></path></svg>';

  const getFormVariantId = (form) => {
    if (!form) return '';
    const formData = new FormData(form);
    return String(formData.get('id') || '');
  };

  const syncAddToBagButtons = (cart) => {
    const cartVariantIds = new Set((cart.items || []).map((item) => String(item.variant_id)));

    document.querySelectorAll('form[data-tie-add-to-cart]').forEach((form) => {
      const button = form.querySelector('button[type="submit"]:not([name="checkout"])');
      if (!button) return;

      if (!button.dataset.tieDefaultHtml) {
        button.dataset.tieDefaultHtml = button.innerHTML;
      }

      const isInCart = cartVariantIds.has(getFormVariantId(form));
      button.classList.toggle('is-success', isInCart);

      if (isInCart) {
        button.innerHTML = `Added to Bag ${bagIconMarkup}`;
      } else if (!button.classList.contains('is-loading')) {
        button.innerHTML = button.dataset.tieDefaultHtml;
      }
    });
  };

  const renderSideCartUpsells = (cart) => {
    if (!sideCartUpsells.length) return '';

    const cartProductIds = new Set((cart.items || []).map((item) => Number(item.product_id)));
    const availableUpsells = sideCartUpsells
      .filter((product) => product.available && !cartProductIds.has(Number(product.product_id)))
      .slice(0, 4);

    if (!availableUpsells.length) return '';

    const upsellCards = availableUpsells.map((product) => `
      <article class="tie-side-cart__upsell-card">
        <a class="tie-side-cart__upsell-image" href="${escapeHtml(product.url)}">
          <img src="${escapeHtml(product.image || fallbackCartImage)}" alt="${escapeHtml(product.title)}" loading="lazy">
        </a>
        <div class="tie-side-cart__upsell-copy">
          <h4><a href="${escapeHtml(product.url)}">${escapeHtml(product.title)}</a></h4>
          <p>${escapeHtml(formatMoney(product.price))}</p>
        </div>
        <button class="tie-side-cart__upsell-button" type="button" data-tie-cart-upsell-add="${Number(product.variant_id)}">Add to Bag ${bagIconMarkup}</button>
      </article>
    `).join('');

    return `
      <section class="tie-side-cart__upsells" aria-labelledby="TieSideCartUpsellsTitle">
        <div class="tie-side-cart__upsells-header">
          <p class="tie-eyebrow">Pair it with</p>
          <h3 id="TieSideCartUpsellsTitle">${escapeHtml(sideCartUpsellHeading)}</h3>
        </div>
        <div class="tie-side-cart__upsells-list">${upsellCards}</div>
      </section>
    `;
  };

  const getCartInventory = async () => {
    try {
      const shopifyRoot = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${shopifyRoot}?section_id=tie-cart-inventory`, {
        cache: 'no-store',
        headers: {
          Accept: 'text/html',
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      if (!response.ok) return {};

      const html = await response.text();
      const documentFragment = new DOMParser().parseFromString(html, 'text/html');
      const inventoryScript = documentFragment.querySelector('[data-tie-cart-inventory]');

      if (!inventoryScript) return {};

      return JSON.parse(inventoryScript.textContent || '{}');
    } catch (error) {
      return {};
    }
  };

  const getVariantInventoryLimit = (item, inventoryByVariant) => {
    const inventory = inventoryByVariant?.[String(item.variant_id)];

    if (!inventory || !inventory.tracked || inventory.policy !== 'deny') {
      return null;
    }

    const availableQuantity = Number(inventory.quantity);
    return Number.isFinite(availableQuantity) ? Math.max(0, availableQuantity) : null;
  };

  const renderCartItems = (cart, inventoryByVariant = {}) => {
    if (!sideCartBody || !sideCartFooter) return;

    const upsellMarkup = renderSideCartUpsells(cart);
    const quantitiesByVariant = (cart.items || []).reduce((totals, item) => {
      const variantId = String(item.variant_id);
      totals[variantId] = (totals[variantId] || 0) + Number(item.quantity || 0);
      return totals;
    }, {});

    if (!cart.item_count) {
      sideCartBody.innerHTML = `
        <div class="tie-side-cart__empty">
          <p class="tie-eyebrow">Cart</p>
          <h3>Your bag is quiet for now.</h3>
          <p>Start with a structured handbag, then add the small pieces that make it yours.</p>
        </div>
        ${upsellMarkup}
      `;
    } else {
      const itemsMarkup = cart.items.map((item, index) => {
        const image = item.featured_image?.url
          ? `<img src="${escapeHtml(item.featured_image.url)}&width=240" alt="${escapeHtml(item.product_title)}" loading="lazy">`
          : `<img src="${escapeHtml(fallbackCartImage)}" alt="${escapeHtml(item.product_title)}" loading="lazy">`;
        const inventoryLimit = getVariantInventoryLimit(item, inventoryByVariant);
        const totalVariantQuantity = quantitiesByVariant[String(item.variant_id)] || 0;
        const isAtInventoryLimit = inventoryLimit !== null && totalVariantQuantity >= inventoryLimit;
        const nextQuantity = isAtInventoryLimit ? item.quantity : item.quantity + 1;
        const stockNote = inventoryLimit !== null
          ? `<p class="tie-side-cart__stock-note" role="status">Only ${inventoryLimit} left in stock</p>`
          : '';

        return `
          <article class="tie-side-cart__item">
            <a class="tie-side-cart__image" href="${escapeHtml(item.url)}">${image}</a>
            <div class="tie-side-cart__details">
              <h3><a href="${escapeHtml(item.url)}">${escapeHtml(item.product_title)}</a></h3>
              ${item.variant_title ? `<p>${escapeHtml(item.variant_title)}</p>` : ''}
              <div class="tie-side-cart__meta">
                <span class = "money">${escapeHtml(formatMoney(item.final_line_price))}</span>
              </div>
              ${stockNote}
              <div class="tie-side-cart__quantity">
                <button type="button" aria-label="Decrease quantity" data-tie-cart-change="${index + 1}" data-tie-cart-quantity="${Math.max(0, item.quantity - 1)}">-</button>
                <span>${item.quantity}</span>
                <button
                  type="button"
                  aria-label="Increase quantity"
                  data-tie-cart-change="${index + 1}"
                  data-tie-cart-quantity="${nextQuantity}"
                  ${isAtInventoryLimit ? 'disabled aria-disabled="true" title="Maximum available quantity reached"' : ''}
                >+</button>
              </div>
              <button class="tie-side-cart__remove" type="button" data-tie-cart-change="${index + 1}" data-tie-cart-quantity="0">Remove</button>
            </div>
          </article>
        `;
      }).join('');

      sideCartBody.innerHTML = `${itemsMarkup}${upsellMarkup}`;
    }

    sideCartFooter.innerHTML = `
      <div class="tie-side-cart__summary">
        <span class= "money">Subtotal</span>
        <strong>${escapeHtml(formatMoney(cart.total_price))}</strong>
      </div>
      <form action="/cart" method="post" id="CartDrawer-Form">
        <button class="tie-button" type="submit" name="checkout" id="CartDrawer-Checkout">Checkout</button>
      </form>
    `;

    updateCartCount(cart.item_count);
    syncAddToBagButtons(cart);
  };

  const refreshCart = async (openAfterUpdate) => {
    if (!sideCart) return;

    const shopifyRoot = window.Shopify?.routes?.root || '/';
    const [cartResponse, inventoryByVariant] = await Promise.all([
      fetch(`${shopifyRoot}cart.js`, {
        cache: 'no-store',
        headers: {
          Accept: 'application/json'
        }
      }),
      getCartInventory()
    ]);

    if (!cartResponse.ok) return;

    const cart = await cartResponse.json();
    renderCartItems(cart, inventoryByVariant);

    if (openAfterUpdate) {
      openSideCart();
    }
  };

  const setSubmitting = (form, submitting, submitter = null) => {
    const button = submitter || form?.querySelector('button[type="submit"]:not([data-tie-buy-now])');
    if (!button) return;

    button.disabled = submitting;
    button.classList.toggle('is-loading', submitting);

    if (!submitting) {
      button.classList.remove('is-loading');
    }

    if (!button.dataset.tieDefaultHtml) {
      button.dataset.tieDefaultHtml = button.innerHTML;
    }

    if (submitting) {
      button.innerHTML = 'Adding to Bag&hellip;';
    } else if (!button.classList.contains('is-success')) {
      button.innerHTML = button.dataset.tieDefaultHtml;
    }
  };

  const showButtonSuccess = (form) => {
    const button = form?.querySelector('button[type="submit"]');
    if (!button) return;
    if (!button.dataset.tieDefaultHtml) {
      button.dataset.tieDefaultHtml = button.innerHTML;
    }
    button.classList.remove('is-loading');
    button.classList.add('is-success');
    button.innerHTML = `Added to Bag ${bagIconMarkup}`;
  };

  const syncVariantInputs = (value) => {
    if (!value) return;
    document.querySelectorAll('[data-tie-variant-sync]').forEach((input) => {
      input.value = value;
    });
  };
  const closeHeaderDropdowns = (exceptDropdown = null) => {
  document.querySelectorAll('.tie-header-dropdown[open]').forEach((dropdown) => {
    if (dropdown !== exceptDropdown) {
      dropdown.open = false;
    }
  });
};

document.querySelectorAll('.tie-header-dropdown').forEach((dropdown) => {
  dropdown.addEventListener('toggle', () => {
    if (dropdown.open) {
      closeHeaderDropdowns(dropdown);
    }
  });
});

document.addEventListener('click', (event) => {
  if (!event.target.closest('.tie-header-dropdown')) {
    closeHeaderDropdowns();
  }
});

window.addEventListener('scroll', () => {
  closeHeaderDropdowns();
}, { passive: true });

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    closeHeaderDropdowns();
  }
});
const closeToolbarPopovers = (exceptPopover = null) => {
  document.querySelectorAll('.tie-toolbar-popover[open]').forEach((popover) => {
    if (popover !== exceptPopover) {
      popover.open = false;
    }
  });
};

document.querySelectorAll('.tie-toolbar-popover').forEach((popover) => {
  popover.addEventListener('toggle', () => {
    if (popover.open) {
      closeToolbarPopovers(popover);
    }
  });
});

document.addEventListener('click', (event) => {
  if (!event.target.closest('.tie-toolbar-popover')) {
    closeToolbarPopovers();
  }
});

window.addEventListener('scroll', () => {
  closeToolbarPopovers();
}, { passive: true });

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    closeToolbarPopovers();
  }
});

  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', () => {
      const isOpen = mobileMenu.classList.toggle('is-open');
      menuToggle.setAttribute('aria-expanded', String(isOpen));
    });
  }

  if (searchModal) {
    const openSearch = () => {
      searchModal.classList.add('is-open');
      searchModal.setAttribute('aria-hidden', 'false');
      body.classList.add('tie-body-lock');
      window.setTimeout(() => searchInput?.focus(), 40);
    };

    const closeSearch = () => {
      searchModal.classList.remove('is-open');
      searchModal.setAttribute('aria-hidden', 'true');
      body.classList.remove('tie-body-lock');
    };

    document.querySelectorAll('[data-tie-search-open]').forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        openSearch();
      });
    });

    searchModal.querySelectorAll('[data-tie-search-close]').forEach((button) => {
      button.addEventListener('click', closeSearch);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && searchModal.classList.contains('is-open')) {
        closeSearch();
      }
    });
  }

  if (header && body?.classList.contains('template-index')) {
    const syncHeaderState = () => {
      header.classList.toggle('is-scrolled', window.scrollY > 10);
    };
    syncHeaderState();
    window.addEventListener('scroll', syncHeaderState, { passive: true });
  }

  document.querySelectorAll('.tie-collection-page').forEach((collectionPage) => {
    const buttons = Array.from(collectionPage.querySelectorAll('[data-tie-collection-view]'));
    if (!buttons.length) return;

    const setView = (view) => {
      collectionPage.setAttribute('data-tie-collection-view', view);
      buttons.forEach((button) => {
        const isActive = button.dataset.tieCollectionView === view;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', String(isActive));
      });
    };

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        setView(button.dataset.tieCollectionView || 'grid');
      });
    });
  });

  document.querySelectorAll('[data-tie-accordion]').forEach((accordion) => {
    const items = Array.from(accordion.querySelectorAll('details'));
    if (!items.length) return;

    items.forEach((item) => {
      item.addEventListener('toggle', () => {
        if (!item.open) return;
        items.forEach((other) => {
          if (other !== item) {
            other.open = false;
          }
        });
      });
    });
  });

  document.querySelectorAll('[data-tie-card-media]').forEach((media) => {
    const frames = Array.from(media.querySelectorAll('.tie-product-card__frame'));
    const total = frames.length || 1;
    const counter = media.querySelector('.tie-product-card__counter-index');
    if (frames.length < 2) return;

    let index = 0;
    let timer = null;
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const show = (nextIndex) => {
      index = (nextIndex + frames.length) % frames.length;
      frames.forEach((frame, frameIndex) => {
        frame.classList.toggle('is-active', frameIndex === index);
      });
      if (counter) {
        counter.textContent = String(index + 1);
      }
    };

    const start = () => {
      if (prefersReducedMotion) return;
      if (timer) return;
      timer = window.setInterval(() => show(index + 1), 1050);
    };

    const stop = () => {
      window.clearInterval(timer);
      timer = null;
      show(0);
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          start();
        } else {
          stop();
        }
      });
    }, { threshold: 0.45 });

    observer.observe(media);

    media.addEventListener('pointerenter', start);
    media.addEventListener('pointerleave', stop);
    media.addEventListener('focusin', start);
    media.addEventListener('focusout', stop);
    if (media.parentNode) {
      media.parentNode.addEventListener('mouseleave', stop);
    }

    counter.textContent = String(Math.min(1, total));
    const totalNode = media.querySelector('.tie-product-card__counter-total');
    if (totalNode) {
      totalNode.textContent = String(total);
    }
  });

  document.querySelectorAll('[data-tie-home-collection-media]').forEach((media) => {
    const frames = Array.from(media.querySelectorAll('[data-tie-home-collection-frame]'));
    if (frames.length < 2) return;

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let activeIndex = 0;
    let isVisible = false;
    let timer = null;

    const showFrame = (nextIndex) => {
      activeIndex = (nextIndex + frames.length) % frames.length;
      frames.forEach((frame, frameIndex) => {
        const isActive = frameIndex === activeIndex;
        frame.classList.toggle('is-active', isActive);
        frame.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });
    };

    const stopRotation = () => {
      window.clearInterval(timer);
      timer = null;
    };

    const startRotation = () => {
      if (prefersReducedMotion || !isVisible || document.hidden || timer) return;
      timer = window.setInterval(() => showFrame(activeIndex + 1), 1000);
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        isVisible = entry.isIntersecting;
        if (isVisible) {
          startRotation();
        } else {
          stopRotation();
          showFrame(0);
        }
      });
    }, { threshold: 0.2 });

    observer.observe(media);
    media.addEventListener('pointerenter', stopRotation);
    media.addEventListener('pointerleave', startRotation);
    media.addEventListener('focusin', stopRotation);
    media.addEventListener('focusout', startRotation);

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        stopRotation();
      } else {
        startRotation();
      }
    });
  });

  document.querySelectorAll('[data-tie-motion]').forEach((shell) => {
    const row = shell.querySelector('[data-tie-motion-row]');
    if (!row) return;
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const autoDelayMs = 3200;
    let motionTimer = null;

    const getScrollMax = () => Math.max(0, row.scrollWidth - row.clientWidth);
    const autoScroll = () => {
      const nextLeft = row.scrollLeft + Math.round(row.clientWidth * 0.82);
      row.scrollTo({
        left: nextLeft >= getScrollMax() ? 0 : nextLeft,
        behavior: 'smooth'
      });
    };
    const startMotion = () => {
      if (prefersReducedMotion || motionTimer || getScrollMax() === 0) return;
      motionTimer = window.setInterval(autoScroll, autoDelayMs);
    };
    const stopMotion = () => {
      window.clearInterval(motionTimer);
      motionTimer = null;
    };

    startMotion();

    row.addEventListener('mouseenter', stopMotion);
    row.addEventListener('mouseleave', startMotion);
    row.addEventListener('focusin', stopMotion);
    row.addEventListener('focusout', startMotion);

    shell.querySelectorAll('[data-tie-motion-arrow]').forEach((button) => {
      button.addEventListener('click', () => {
        const direction = button.dataset.tieMotionArrow === 'next' ? 1 : -1;
        row.scrollBy({
          left: direction * Math.round(row.clientWidth * 0.76),
          behavior: 'smooth'
        });
      });
    });
  });

  document.querySelectorAll('[data-tie-why-slider]').forEach((shell) => {
  const row = shell.querySelector('[data-tie-why-slider-row]');
  if (!row) return;

  const getStep = () => {
    const firstSlide = row.querySelector('.tie-why__body');
    return firstSlide ? firstSlide.getBoundingClientRect().width : row.clientWidth;
  };

  const getScrollEnd = () => Math.max(0, row.scrollWidth - row.clientWidth);

  shell.querySelectorAll('[data-tie-why-arrow]').forEach((button) => {
    button.addEventListener('click', () => {
      const direction = button.dataset.tieWhyArrow === 'next' ? 1 : -1;
      const scrollEnd = getScrollEnd();
      const currentLeft = row.scrollLeft;
      const nextOffset = currentLeft + (direction * getStep());

      let target = Math.max(0, Math.min(scrollEnd, nextOffset));

      if (direction > 0 && currentLeft >= scrollEnd - 2) {
        target = 0;
      } else if (direction < 0 && currentLeft <= 2) {
        target = scrollEnd;
      }

      row.scrollTo({
        left: target,
        behavior: 'smooth'
      });
    });
  });
});

  document.querySelectorAll('[data-tie-product-slider]').forEach((shell) => {
  const row = shell.querySelector('[data-tie-product-slider-row]');
  if (!row) return;

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const autoDelayMs = 3600;
  let sliderTimer = null;

  const getStep = () => {
    const firstCard = row.querySelector('.tie-product-card');
    if (!firstCard) return row.clientWidth;

    const cardWidth = firstCard.getBoundingClientRect().width;
    const gap = parseFloat(window.getComputedStyle(row).columnGap || window.getComputedStyle(row).gap || 0);

    return cardWidth + gap;
  };

  const getScrollEnd = () => Math.max(0, row.scrollWidth - row.clientWidth);

  const scrollByDirection = (direction) => {
    const scrollEnd = getScrollEnd();
    const currentLeft = row.scrollLeft;
    const nextOffset = currentLeft + (direction * getStep());

    let target = Math.max(0, Math.min(scrollEnd, nextOffset));

    if (direction > 0 && currentLeft >= scrollEnd - 2) {
      target = 0;
    } else if (direction < 0 && currentLeft <= 2) {
      target = scrollEnd;
    }

    row.scrollTo({
      left: target,
      behavior: 'smooth'
    });
  };

  const autoAdvance = () => {
    if (getScrollEnd() <= 0) return;
    scrollByDirection(1);
  };

  const startSlider = () => {
    if (prefersReducedMotion || sliderTimer || getScrollEnd() <= 0) return;
    sliderTimer = window.setInterval(autoAdvance, autoDelayMs);
  };

  const stopSlider = () => {
    window.clearInterval(sliderTimer);
    sliderTimer = null;
  };

  startSlider();

  row.addEventListener('mouseenter', stopSlider);
  row.addEventListener('mouseleave', startSlider);
  row.addEventListener('focusin', stopSlider);
  row.addEventListener('focusout', startSlider);

  shell.querySelectorAll('[data-tie-product-slider-arrow]').forEach((button) => {
    button.addEventListener('click', () => {
      stopSlider();
      const direction = button.dataset.tieProductSliderArrow === 'next' ? 1 : -1;
      scrollByDirection(direction);
    });
  });
});

  document.querySelectorAll('[data-tie-editorial-slider]').forEach((shell) => {
    const row = shell.querySelector('[data-tie-editorial-slider-row]');
    if (!row) return;

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const autoDelayMs = 4600;
    let sliderTimer = null;

    const getStep = () => row.clientWidth;
    const getScrollEnd = () => Math.max(0, row.scrollWidth - row.clientWidth);
    const autoAdvance = () => {
      const nextOffset = row.scrollLeft + getStep();
      row.scrollTo({
        left: nextOffset >= getScrollEnd() - 2 ? 0 : nextOffset,
        behavior: 'smooth'
      });
    };

    const startSlider = () => {
      if (prefersReducedMotion || sliderTimer || getScrollEnd() <= 0) return;
      sliderTimer = window.setInterval(autoAdvance, autoDelayMs);
    };

    const stopSlider = () => {
      window.clearInterval(sliderTimer);
      sliderTimer = null;
    };

    startSlider();

    row.addEventListener('mouseenter', stopSlider);
    row.addEventListener('mouseleave', startSlider);
    row.addEventListener('focusin', stopSlider);
    row.addEventListener('focusout', startSlider);

    shell.querySelectorAll('[data-tie-editorial-slider-arrow]').forEach((button) => {
      button.addEventListener('click', () => {
        const direction = button.dataset.tieEditorialSliderArrow === 'next' ? 1 : -1;
        const nextOffset = row.scrollLeft + (direction * getStep());
        const target = direction > 0 && nextOffset > getScrollEnd()
          ? 0
          : Math.max(0, nextOffset);
        row.scrollTo({
          left: target,
          behavior: 'smooth'
        });
      });
    });
  });

  document.querySelectorAll('[data-tie-product-marquee]').forEach((viewport) => {
  const track = viewport.querySelector('[data-tie-product-marquee-track]');
  if (!track) return;

  const shell = viewport.closest('.tie-product-marquee');
  const slider = viewport.closest('.tie-product-marquee__slider');
  track.style.transform = 'none';

  // Keep the carousel arrows vertically centered against the product image,
  // not against the full card (title, price and Add to Bag included).
  const positionMarqueeArrows = () => {
    if (!slider) return;

    const firstMedia = track.querySelector('.tie-product-card__media');
    if (!firstMedia) return;

    const sliderRect = slider.getBoundingClientRect();
    const mediaRect = firstMedia.getBoundingClientRect();
    const mediaCenterY = (mediaRect.top - sliderRect.top) + (mediaRect.height / 2);

    slider.style.setProperty('--tie-product-marquee-arrow-y', `${mediaCenterY}px`);
  };

  window.requestAnimationFrame(positionMarqueeArrows);
  window.addEventListener('resize', positionMarqueeArrows, { passive: true });

  if ('ResizeObserver' in window) {
    const marqueeResizeObserver = new ResizeObserver(positionMarqueeArrows);
    marqueeResizeObserver.observe(viewport);
  }

  const getStep = () => {
    const firstCard = track.querySelector('.tie-product-card');
    if (!firstCard) return viewport.clientWidth;

    const styles = window.getComputedStyle(track);
    const gapValue = styles.columnGap !== 'normal' ? styles.columnGap : styles.gap;
    const gap = parseFloat(gapValue) || 0;

    return firstCard.getBoundingClientRect().width + gap;
  };

  const getScrollEnd = () => Math.max(0, viewport.scrollWidth - viewport.clientWidth);

  const scrollByDirection = (direction) => {
    const scrollEnd = getScrollEnd();
    const currentLeft = viewport.scrollLeft;
    const nextOffset = currentLeft + (direction * getStep());

    let target = Math.max(0, Math.min(scrollEnd, nextOffset));

    if (direction > 0 && currentLeft >= scrollEnd - 2) {
      target = 0;
    } else if (direction < 0 && currentLeft <= 2) {
      target = scrollEnd;
    }

    viewport.scrollTo({
      left: target,
      behavior: 'smooth'
    });
  };

  shell?.querySelectorAll('[data-tie-product-marquee-arrow]').forEach((button) => {
    button.addEventListener('click', () => {
      const direction = button.dataset.tieProductMarqueeArrow === 'next' ? 1 : -1;
      scrollByDirection(direction);
    });
  });

  let isDown = false;
  let startX = 0;
  let scrollLeft = 0;
  let dragged = false;

  viewport.addEventListener('mousedown', (event) => {
    isDown = true;
    dragged = false;
    startX = event.pageX - viewport.offsetLeft;
    scrollLeft = viewport.scrollLeft;
    viewport.classList.add('is-dragging');
  });

  viewport.addEventListener('mouseleave', () => {
    isDown = false;
    viewport.classList.remove('is-dragging');
  });

  viewport.addEventListener('mouseup', () => {
    isDown = false;
    viewport.classList.remove('is-dragging');
  });

  viewport.addEventListener('mousemove', (event) => {
    if (!isDown) return;

    event.preventDefault();

    const x = event.pageX - viewport.offsetLeft;
    const walk = (x - startX) * 1.4;

    if (Math.abs(walk) > 4) {
      dragged = true;
    }

    viewport.scrollLeft = scrollLeft - walk;
  });

  viewport.querySelectorAll('a').forEach((link) => {
    link.addEventListener('click', (event) => {
      if (dragged) {
        event.preventDefault();
      }
    });
  });
});

  document.querySelectorAll('[data-tie-product-media]').forEach((gallery) => {
    const tiles = Array.from(gallery.querySelectorAll('[data-tie-product-media-tile]'));
    if (!tiles.length) return;
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    tiles.forEach((tile) => {
      const image = tile.querySelector(':scope > img');

if (!image) return;
      const stack = (tile.dataset.tieProductMediaStack || '').split('||').filter(Boolean);
      const maxFrames = Math.max(1, stack.length || 1);
      const frameLabels = [
        tile.dataset.tieProductMediaIndex || '1',
        tile.dataset.tieProductMediaNextIndex || tile.dataset.tieProductMediaIndex || '1'
      ];
      const counterIndex = tile.querySelector('.tie-product-media__counter-index');
      const counterTotal = tile.querySelector('.tie-product-media__counter-total');

      if (counterTotal) {
        counterTotal.textContent = String(tile.dataset.tieProductMediaTotal || counterTotal.textContent || maxFrames);
      }
      if (!image || maxFrames < 2) {
        if (counterIndex) {
          counterIndex.textContent = frameLabels[0];
        }
        return;
      }

      if (counterIndex) {
        counterIndex.textContent = frameLabels[0];
      }

      let index = 0;
      let timer = null;
      let hasStarted = false;
      const start = () => {
        if (prefersReducedMotion || timer) return;
        timer = window.setInterval(() => {
          index = (index + 1) % maxFrames;
          image.src = stack[index];
          if (counterIndex) {
            counterIndex.textContent = frameLabels[index] || String(index + 1);
          }
        }, 900);
      };
      const stop = () => {
        window.clearInterval(timer);
        timer = null;
      };

      const reset = () => {
        index = 0;
        image.src = stack[0];
        if (counterIndex) {
          counterIndex.textContent = frameLabels[0];
        }
      };

      tile.addEventListener('pointerenter', () => {
        hasStarted = true;
        start();
      });
      tile.addEventListener('pointerleave', () => {
        if (hasStarted) {
          stop();
          reset();
          hasStarted = false;
        }
      });
      tile.addEventListener('focusin', start);
      tile.addEventListener('focusout', stop);
    });
  });

  document.querySelectorAll('[data-tie-open-cart]').forEach((trigger) => {
    trigger.addEventListener('click', async (event) => {
      if (!sideCart) return;
      event.preventDefault();
      await refreshCart(true);
    });
  });

  if (sideCart) {
    sideCart.querySelectorAll('[data-tie-side-cart-close]').forEach((button) => {
      button.addEventListener('click', closeSideCart);
    });

    sideCart.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-tie-cart-change]');
      if (button) {
        button.disabled = true;
        const line = Number(button.dataset.tieCartChange);
        const quantity = Number(button.dataset.tieCartQuantity);

        try {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({ line, quantity })
          });
          await refreshCart(false);
        } finally {
          button.disabled = false;
        }
        return;
      }

      const upsellButton = event.target.closest('[data-tie-cart-upsell-add]');
      if (!upsellButton) return;

      upsellButton.disabled = true;

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            Accept: 'application/json'
          },
          body: new URLSearchParams({
            id: upsellButton.dataset.tieCartUpsellAdd,
            quantity: '1'
          })
        });

        if (response.ok) {
          upsellButton.innerHTML = `Added to Bag ${bagIconMarkup}`;
          await refreshCart(false);
        }
      } finally {
        window.setTimeout(() => {
          upsellButton.disabled = false;
          if (upsellButton.isConnected) {
            upsellButton.innerHTML = `Add to Bag ${bagIconMarkup}`;
          }
        }, 900);
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeSideCart();
      }
    });
  }

  document.querySelectorAll('form[data-tie-add-to-cart]').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      const submitter = event.submitter;
      const isBuyNow = Boolean(submitter?.matches('[data-tie-buy-now]'));

      if (isBuyNow || !sideCart) return;

      event.preventDefault();
      setSubmitting(form, true, submitter);

      try {
        const shopifyRoot = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${shopifyRoot}cart/add.js`, {
          method: 'POST',
          headers: {
            Accept: 'application/json'
          },
          body: new FormData(form)
        });

        if (!response.ok) {
          setSubmitting(form, false, submitter);
          return;
        }

        await refreshCart(true);
        showButtonSuccess(form);
      } finally {
        setSubmitting(form, false, submitter);
      }
    });
  });

  const refreshProductMediaCounters = (gallery) => {
  const tiles = Array.from(gallery.querySelectorAll('[data-tie-product-media-tile]'));
  const total = tiles.length;

  tiles.forEach((tile, index) => {
    const position = index + 1;
    const nextPosition = position >= total ? 1 : position + 1;
    const counterIndex = tile.querySelector('.tie-product-media__counter-index');
    const counterTotal = tile.querySelector('.tie-product-media__counter-total');

    tile.dataset.tieProductMediaIndex = String(position);
    tile.dataset.tieProductMediaNextIndex = String(nextPosition);
    tile.dataset.tieProductMediaTotal = String(total);

    if (counterIndex) counterIndex.textContent = String(position);
    if (counterTotal) counterTotal.textContent = String(total);
  });
};

const showSelectedVariantImageFirst = (select) => {
  const selectedOption = select.options[select.selectedIndex];
  if (!selectedOption) return;

  const variantMediaId = selectedOption.dataset.tieVariantMediaId;
  const variantImage = selectedOption.dataset.tieVariantImage;

  const productSection = select.closest('.tie-product-template');
  const gallery = productSection?.querySelector('[data-tie-product-media]');

  if (!gallery) return;

  let targetTile = null;

  if (variantMediaId) {
    targetTile = gallery.querySelector(`[data-tie-product-media-id="${variantMediaId}"]`);
  }

  if (targetTile) {
    gallery.prepend(targetTile);

    const image = targetTile.querySelector('img');
    const originalImage = (targetTile.dataset.tieProductMediaStack || '').split('||').filter(Boolean)[0];

    if (image && originalImage) {
      image.src = originalImage;
      image.srcset = originalImage;
    }

    refreshProductMediaCounters(gallery);
    return;
  }

  if (variantImage) {
    const firstTile = gallery.querySelector('[data-tie-product-media-tile]');
    const firstImage = firstTile?.querySelector('img');

    if (firstImage) {
      firstImage.src = variantImage;
      firstImage.srcset = variantImage;
    }
  }
};

const productVariantsScript = document.querySelector('[data-tie-product-variants-json]');
let productVariants = [];

try {
  productVariants = productVariantsScript
    ? JSON.parse(productVariantsScript.textContent || '[]')
    : [];
} catch (error) {
  productVariants = [];
}

const productVariantAssetsScript = document.querySelector('[data-tie-variant-assets]');
let productVariantAssets = {};

try {
  productVariantAssets = productVariantAssetsScript
    ? JSON.parse(productVariantAssetsScript.textContent || '{}')
    : {};
} catch (error) {
  productVariantAssets = {};
}
const normalizeVariantValue = (value) => String(value || '').trim().toLowerCase();

const getSelectedProductVariant = (select) => (
  productVariants.find((variant) => String(variant.id) === String(select.value)) || null
);

const updateProductPrice = (select, selectedVariant) => {
  if (!selectedVariant) return;

  const productSection = select.closest('.tie-product-template');
  const priceElement = productSection?.querySelector('.tie-product-price');
  const stickyPriceElement = document.querySelector(
    '.tie-product-sticky-bar__meta span'
  );

  const price = Number(selectedVariant.price || 0);
  const compareAtPrice = Number(selectedVariant.compare_at_price || 0);

  if (priceElement) {
    const currentPriceElement = priceElement.querySelector('[data-tie-product-current-price]');
    let comparePriceElement = priceElement.querySelector('[data-tie-product-compare-price]');

    setConvertibleMoney(currentPriceElement, formatMoney(price), price / 100);

    if (compareAtPrice > price) {
      if (!comparePriceElement) {
        comparePriceElement = document.createElement('s');
        comparePriceElement.className = 'money';
        comparePriceElement.setAttribute('data-tie-product-compare-price', '');
        priceElement.append(comparePriceElement);
      }

      setConvertibleMoney(
        comparePriceElement,
        formatMoney(compareAtPrice),
        compareAtPrice / 100
      );
    } else if (comparePriceElement) {
      comparePriceElement.remove();
    }
  }

  if (stickyPriceElement) {
    stickyPriceElement.textContent = formatMoney(price);
  }
};

const updateProductAvailability = (select, selectedVariant) => {
  if (!selectedVariant) return;

  const isAvailable = Boolean(selectedVariant.available);
  const productForm = select.closest('.tie-product-form');

  const addButton = productForm?.querySelector('.tie-button--primary');
  const buyNowButton = productForm?.querySelector('.tie-button--buy-now');
  const stickyButton = document.querySelector(
    '.tie-product-sticky-bar__form .tie-button--primary'
  );

  if (addButton) {
    addButton.disabled = !isAvailable;
    addButton.innerHTML = isAvailable ? `Add to Bag ${bagIconMarkup}` : 'Sold Out';
    addButton.dataset.tieDefaultHtml = addButton.innerHTML;
  }

  if (buyNowButton) {
    buyNowButton.disabled = !isAvailable;
  }

  if (stickyButton) {
    stickyButton.disabled = !isAvailable;
    stickyButton.innerHTML = isAvailable ? `Add to Bag ${bagIconMarkup}` : 'Sold Out';
    stickyButton.dataset.tieDefaultHtml = stickyButton.innerHTML;
  }
};

document.querySelectorAll('[data-tie-variant-select]').forEach((select) => {
  const updateSelectedVariant = () => {
    const selectedVariant = getSelectedProductVariant(select);
    const colorIndex = Number.parseInt(
      select.dataset.tieColorOptionIndex,
      10
    );

    const selectedColor = (
      selectedVariant &&
      Array.isArray(selectedVariant.options) &&
      !Number.isNaN(colorIndex)
    )
      ? selectedVariant.options[colorIndex]
      : '';

    /*
     * Update the variant used by the sticky add-to-cart form.
     */
    syncVariantInputs(select.value);

    /*
     * Move the selected variant image to the first position.
     */
    showSelectedVariantImageFirst(select);

    /*
     * Update price, compare-at price and button availability.
     */
    updateProductPrice(select, selectedVariant);
    updateProductAvailability(select, selectedVariant);

    /*
     * Update the active colour swatch.
     */
    const productSection = select.closest('.tie-product-template');

    const swatches = productSection
      ? productSection.querySelectorAll('[data-tie-color-swatch]')
      : document.querySelectorAll('[data-tie-color-swatch]');

    swatches.forEach((swatch) => {
      const swatchValue = swatch.dataset.tieColorSwatch || '';

      const isActive = (
        normalizeVariantValue(swatchValue) ===
        normalizeVariantValue(selectedColor)
      );

      swatch.classList.toggle('is-active', isActive);
      swatch.setAttribute('aria-pressed', String(isActive));
    });
  };

  /*
   * Run once when the page loads.
   */
  updateSelectedVariant();

  /*
   * Run whenever the combined variant dropdown changes.
   */
  select.addEventListener('change', updateSelectedVariant);
});

document.querySelectorAll('[data-tie-color-swatch]').forEach((swatch) => {
  swatch.addEventListener('click', () => {
    const swatchValue = swatch.dataset.tieColorSwatch || '';
    const productSection = swatch.closest('.tie-product-template');

    const select = productSection?.querySelector(
      '[data-tie-variant-select]'
    );

    if (!select || !swatchValue) return;

    const colorIndex = Number.parseInt(
      select.dataset.tieColorOptionIndex,
      10
    );

    const currentVariant = getSelectedProductVariant(select);
    const normalizedSwatchValue = normalizeVariantValue(swatchValue);

    let targetVariant = null;

    /*
     * First try to find the selected colour while keeping
     * the current size and every other option unchanged.
     */
    if (!Number.isNaN(colorIndex)) {
      targetVariant = productVariants.find((variant) => {
        if (!variant.available || !Array.isArray(variant.options)) {
          return false;
        }

        const colorMatches = (
          normalizeVariantValue(variant.options[colorIndex]) ===
          normalizedSwatchValue
        );

        const otherOptionsMatch = (
          !currentVariant ||
          !Array.isArray(currentVariant.options)
        )
          ? true
          : variant.options.every((optionValue, optionIndex) => (
              optionIndex === colorIndex ||
              normalizeVariantValue(optionValue) ===
                normalizeVariantValue(currentVariant.options[optionIndex])
            ));

        return colorMatches && otherOptionsMatch;
      });

      /*
       * If that size-colour combination is unavailable,
       * use the first available variant of that colour.
       */
      if (!targetVariant) {
        targetVariant = productVariants.find((variant) => (
          variant.available &&
          Array.isArray(variant.options) &&
          normalizeVariantValue(variant.options[colorIndex]) ===
            normalizedSwatchValue
        ));
      }
    }

    const option = targetVariant
      ? Array.from(select.options).find((item) => (
          String(item.value) === String(targetVariant.id)
        ))
      : Array.from(select.options).find((item) => (
          !item.disabled &&
          normalizeVariantValue(item.text).includes(
            normalizedSwatchValue
          )
        ));

    if (!option) return;

    select.value = option.value;
    select.dispatchEvent(new Event('change', { bubbles: true }));
  });
});
  const wishlistKey = 'tieWishlistProducts';

  const getWishlist = () => {
    try {
      return JSON.parse(localStorage.getItem(wishlistKey)) || [];
    } catch (error) {
      return [];
    }
  };

  const setWishlist = (items) => {
    localStorage.setItem(wishlistKey, JSON.stringify(items));
  };

  const escapeWishlistHtml = (value = '') => String(value).replace(/[&<>"']/g, (char) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#039;'
  }[char]));
  const cleanWishlistText = (value = '') => String(value).replace(/<[^>]*>/g, '').trim();

  const ensureWishlistDrawer = () => {
    let drawer = document.querySelector('[data-tie-wishlist-drawer]');
    if (drawer) return drawer;

    document.body.insertAdjacentHTML('beforeend', `
      <aside class="tie-wishlist-drawer" aria-hidden="true" data-tie-wishlist-drawer>
        <button class="tie-wishlist-drawer__backdrop" type="button" aria-label="Close wishlist" data-tie-wishlist-close></button>
        <div class="tie-wishlist-drawer__panel" role="dialog" aria-modal="true" aria-label="Wishlist">
          <header class="tie-wishlist-drawer__header">
            <h2>Wishlist</h2>
            <button type="button" aria-label="Close wishlist" data-tie-wishlist-close>&times;</button>
          </header>
          <div class="tie-wishlist-drawer__body" data-tie-wishlist-items></div>
        </div>
      </aside>
    `);

    drawer = document.querySelector('[data-tie-wishlist-drawer]');

    drawer.querySelectorAll('[data-tie-wishlist-close]').forEach((button) => {
      button.addEventListener('click', () => {
        document.body.classList.remove('tie-wishlist-open');
        drawer.setAttribute('aria-hidden', 'true');
      });
    });

    return drawer;
  };

  const renderWishlistDrawer = () => {
    const drawer = ensureWishlistDrawer();
    const container = drawer.querySelector('[data-tie-wishlist-items]');
    const items = getWishlist();

    if (!container) return;

    if (!items.length) {
      container.innerHTML = '<p class="tie-wishlist-empty">Your wishlist is empty.</p>';
      return;
    }

    container.innerHTML = items.map((item) => `
      <div class="tie-wishlist-item">
        <a class="tie-wishlist-item__image" href="${escapeWishlistHtml(item.url)}">
          ${item.image ? `<img src="${escapeWishlistHtml(item.image)}" alt="${escapeWishlistHtml(item.title)}" loading="lazy">` : ''}
        </a>
        <div class="tie-wishlist-item__content">
          <a href="${escapeWishlistHtml(item.url)}">${escapeWishlistHtml(item.title)}</a>
          ${item.price ? `<p>${escapeWishlistHtml(cleanWishlistText(item.price))}</p>` : ''}
          <button type="button" data-tie-wishlist-remove="${escapeWishlistHtml(item.handle)}">Remove</button>
        </div>
      </div>
    `).join('');
  };

  const updateWishlistUI = () => {
    const items = getWishlist();
    const handles = new Set(items.map((item) => item.handle));

    document.querySelectorAll('[data-tie-wishlist-toggle]').forEach((button) => {
      const handle = button.dataset.productHandle;
      const isActive = handles.has(handle);

      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', String(isActive));
    });

    document.querySelectorAll('[data-tie-wishlist-count]').forEach((count) => {
      count.textContent = String(items.length);
      count.hidden = items.length === 0;
    });

    const drawer = document.querySelector('[data-tie-wishlist-drawer]');
    if (drawer && drawer.getAttribute('aria-hidden') === 'false') {
      renderWishlistDrawer();
    }
  };

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-tie-wishlist-toggle]');
    if (toggle) {
      event.preventDefault();
      event.stopPropagation();

      const handle = toggle.dataset.productHandle;
      if (!handle) return;

      const product = {
        handle,
        title: toggle.dataset.productTitle || '',
        url: toggle.dataset.productUrl || '',
        image: toggle.dataset.productImage || '',
        price: cleanWishlistText(toggle.dataset.productPrice || '')
      };

      let items = getWishlist();
      const exists = items.some((item) => item.handle === handle);

      if (exists) {
        items = items.filter((item) => item.handle !== handle);
      } else {
        items.unshift(product);
      }

      setWishlist(items);
      updateWishlistUI();
      return;
    }

    const openButton = event.target.closest('[data-tie-wishlist-open]');
    if (openButton) {
      event.preventDefault();

      const drawer = ensureWishlistDrawer();
      renderWishlistDrawer();

      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('tie-wishlist-open');
      return;
    }

    const removeButton = event.target.closest('[data-tie-wishlist-remove]');
    if (removeButton) {
      event.preventDefault();

      const handle = removeButton.dataset.tieWishlistRemove;
      const items = getWishlist().filter((item) => item.handle !== handle);

      setWishlist(items);
      renderWishlistDrawer();
      updateWishlistUI();
    }
  });

  updateWishlistUI();
  const setupVariantMediaFilter = () => {
  const gallery = document.querySelector('[data-tie-product-media]');
  const tiles = Array.from(document.querySelectorAll('[data-tie-product-media-tile]'));
  const select = document.querySelector('[data-tie-variant-select]');

  if (!gallery || !tiles.length || !select) return;

  const variantsScript = document.querySelector('[data-tie-product-variants-json]');
  let variants = [];

  try {
    variants = variantsScript ? JSON.parse(variantsScript.textContent || '[]') : [];
  } catch (error) {
    variants = [];
  }

  const normalize = (value) => String(value || '')
    .toLowerCase()
    .replace(/variant\s*:/g, '')
    .replace(/color\s*:/g, '')
    .replace(/colour\s*:/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

  const getSelectedVariant = () => variants.find((variant) => String(variant.id) === String(select.value));

  const getSelectedMediaKey = () => {
    const selectedVariant = getSelectedVariant();
    const colorIndex = parseInt(select.dataset.tieColorOptionIndex, 10);

    if (
      selectedVariant &&
      Array.isArray(selectedVariant.options) &&
      !Number.isNaN(colorIndex) &&
      selectedVariant.options[colorIndex]
    ) {
      return normalize(selectedVariant.options[colorIndex]);
    }

    const selectedText = select.options[select.selectedIndex]?.text || '';
    return normalize(selectedText.replace('- Sold out', ''));
  };

  const getMediaKeys = (rawValue) => {
    const value = String(rawValue || '').trim();

    if (!value) return [];

    const explicitVariantMatches = [...value.matchAll(/variant\s*:\s*([^|,;]+)/gi)]
      .map((match) => normalize(match[1]))
      .filter(Boolean);

    if (explicitVariantMatches.length) {
      return explicitVariantMatches;
    }

    return [normalize(value)];
  };

  const mediaMatchesVariant = (tile, selectedKey) => {
    const rawValue = tile.dataset.tieVariantMedia || '';

    if (!rawValue.trim()) {
      return true;
    }

    const mediaKeys = getMediaKeys(rawValue);

    if (mediaKeys.includes('all')) {
      return true;
    }

    return mediaKeys.some((mediaKey) => (
      mediaKey === selectedKey ||
      mediaKey.includes(selectedKey) ||
      selectedKey.includes(mediaKey)
    ));
  };

  const updateCounters = (visibleTiles) => {
    visibleTiles.forEach((tile, index) => {
      const counterIndex = tile.querySelector('.tie-product-media__counter-index');
      const counterTotal = tile.querySelector('.tie-product-media__counter-total');

      if (counterIndex) {
        counterIndex.textContent = String(index + 1);
      }

      if (counterTotal) {
        counterTotal.textContent = String(visibleTiles.length);
      }
    });
  };

  const applyVariantMediaFilter = () => {
    const selectedKey = getSelectedMediaKey();

    if (!selectedKey) return;

    let visibleTiles = [];

    tiles.forEach((tile) => {
      const shouldShow = mediaMatchesVariant(tile, selectedKey);

      tile.hidden = !shouldShow;
      tile.classList.toggle('is-hidden-by-variant', !shouldShow);

      if (shouldShow) {
        visibleTiles.push(tile);
      }
    });

    if (!visibleTiles.length) {
      tiles.forEach((tile) => {
        tile.hidden = false;
        tile.classList.remove('is-hidden-by-variant');
      });

      visibleTiles = tiles;
    }

    updateCounters(visibleTiles);

    if (typeof gallery.scrollTo === 'function') {
      gallery.scrollTo({
        left: 0,
        top: 0,
        behavior: 'auto'
      });
    }
  };

  applyVariantMediaFilter();
  select.addEventListener('change', applyVariantMediaFilter);
};

setupVariantMediaFilter();
  setupReadMoreCards();
  refreshCart(false);
})();

(function () {
  const normalizeColor = (value) => String(value || '').trim().toLowerCase();

  const parseProductVariants = (root) => {
    const script = root.querySelector('[data-tie-product-variants-json]')
      || document.querySelector('[data-tie-product-variants-json]');

    if (!script) return [];

    try {
      return JSON.parse(script.textContent || '[]');
    } catch (error) {
      return [];
    }
  };

  const getColorVariant = (root, colorName) => {
    const select = root.querySelector('[data-tie-variant-select]');
    const variants = parseProductVariants(root);

    if (!select || !variants.length) return null;

    const colorIndex = Number.parseInt(select.dataset.tieColorOptionIndex, 10);
    const currentVariant = variants.find(
      (variant) => String(variant.id) === String(select.value)
    );
    const normalizedColor = normalizeColor(colorName);

    const matchesColorAndOtherOptions = (variant) => {
      if (!variant.available || !Array.isArray(variant.options)) return false;
      if (Number.isNaN(colorIndex)) return false;

      const colorMatches = normalizeColor(variant.options[colorIndex]) === normalizedColor;
      const otherOptionsMatch = !currentVariant || !Array.isArray(currentVariant.options)
        ? true
        : variant.options.every((value, index) => (
          index === colorIndex
          || normalizeColor(value) === normalizeColor(currentVariant.options[index])
        ));

      return colorMatches && otherOptionsMatch;
    };

    return variants.find(matchesColorAndOtherOptions)
      || variants.find((variant) => (
        variant.available
        && Array.isArray(variant.options)
        && normalizeColor(variant.options[colorIndex]) === normalizedColor
      ))
      || null;
  };

  const renderColorThumbnails = (root) => {
    const select = root.querySelector('[data-tie-variant-select]');
    const swatches = Array.from(root.querySelectorAll('[data-tie-color-swatch]'));
    const variantAssetScript = document.querySelector('[data-tie-variant-assets]');
    let variantAssetMap = {};

    try {
      variantAssetMap = variantAssetScript
        ? JSON.parse(variantAssetScript.textContent || '{}')
        : {};
    } catch (error) {
      variantAssetMap = {};
    }

    if (!select || !swatches.length) return;

    swatches.forEach((swatch) => {
      const colorName = swatch.dataset.tieColorSwatch || '';
      const variant = getColorVariant(root, colorName);
      const option = variant
        ? Array.from(select.options).find((item) => String(item.value) === String(variant.id))
        : null;
      const imageUrl = swatch.dataset.tieColorThumbnailOverride
        || variantAssetMap[String(variant?.id || '')]
        || option?.dataset.tieVariantImage
        || variant?.featured_image?.src
        || '';

      if (!imageUrl) return;

      const media = swatch.querySelector('[data-tie-color-thumbnail-media]') || swatch;
      let image = media.querySelector('img[data-tie-color-thumbnail]');

      if (!image) {
        image = document.createElement('img');
        image.dataset.tieColorThumbnail = 'true';
        image.loading = 'lazy';
        image.decoding = 'async';
        media.replaceChildren(image);
      }

      image.src = imageUrl;
      image.alt = `${colorName} ${root.querySelector('h1')?.textContent?.trim() || 'product'} image`;
      swatch.dataset.tieColorImageReady = 'true';
      swatch.removeAttribute('style');
    });
  };

  const initializeColorThumbnails = (scope = document) => {
    scope.querySelectorAll('.tie-product-template').forEach(renderColorThumbnails);
  };

  initializeColorThumbnails();

  document.querySelectorAll('[data-tie-variant-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const root = select.closest('.tie-product-template');
      if (root) renderColorThumbnails(root);
    });
  });

  document.addEventListener('shopify:section:load', (event) => {
    initializeColorThumbnails(event.target);
  });
})();

(function () {
  const initializeProductFeatureCarousels = (scope = document) => {
    scope.querySelectorAll('[data-tie-product-features]').forEach((root) => {
      if (root.dataset.tieFeatureReady === 'true') return;

      const track = root.querySelector('[data-tie-feature-track]');
      const slides = Array.from(root.querySelectorAll('[data-tie-product-feature-slide]'));
      const dots = Array.from(root.querySelectorAll('[data-tie-feature-dot]'));
      const previous = root.querySelector('[data-tie-feature-prev]');
      const next = root.querySelector('[data-tie-feature-next]');

      if (!track || !slides.length) return;

      root.dataset.tieFeatureReady = 'true';
      let activeIndex = 0;

      const goTo = (requestedIndex) => {
        activeIndex = (requestedIndex + slides.length) % slides.length;
        track.style.transform = `translate3d(-${activeIndex * 100}%, 0, 0)`;

        slides.forEach((slide, index) => {
          const isActive = index === activeIndex;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', String(!isActive));
        });

        dots.forEach((dot, index) => {
          const isActive = index === activeIndex;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-current', String(isActive));
        });
      };

      previous?.addEventListener('click', () => goTo(activeIndex - 1));
      next?.addEventListener('click', () => goTo(activeIndex + 1));

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          goTo(Number.parseInt(dot.dataset.tieFeatureDot || '0', 10));
        });
      });

      root.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') goTo(activeIndex - 1);
        if (event.key === 'ArrowRight') goTo(activeIndex + 1);
      });

      goTo(0);
    });
  };

  initializeProductFeatureCarousels();

  document.addEventListener('shopify:section:load', (event) => {
    initializeProductFeatureCarousels(event.target);
  });
})();


/* TIE product compare interactions */
(function () {
  const recentProductsKey = 'tie-recently-viewed-products-v1';
  const recentProductsLimit = 12;

  const readRecentProducts = () => {
    try {
      const parsed = JSON.parse(localStorage.getItem(recentProductsKey) || '[]');
      return Array.isArray(parsed) ? parsed.filter((item) => item && item.id && item.title) : [];
    } catch (error) {
      return [];
    }
  };

  const writeRecentProducts = (products) => {
    try {
      localStorage.setItem(recentProductsKey, JSON.stringify(products));
    } catch (error) {
      // The compare UI still works with collection suggestions when storage is unavailable.
    }
  };

  const initializeProductCompare = (scope = document) => {
    scope.querySelectorAll('[data-tie-product-compare]').forEach((root) => {
      if (root.dataset.tieCompareReady === 'true') return;

      const menu = root.querySelector('[data-tie-compare-menu]');
      const search = root.querySelector('[data-tie-compare-search]');
      const optionsContainer = root.querySelector('[data-tie-compare-options]');
      const emptyState = root.querySelector('[data-tie-compare-empty]');
      const picker = root.querySelector('.tie-product-compare__picker');
      const targetImage = root.querySelector('[data-tie-compare-target-image]');
      const targetName = root.querySelector('[data-tie-compare-target-name]');
      const targetPrice = root.querySelector('[data-tie-compare-target-current-price]');
      const targetComparePrice = root.querySelector('[data-tie-compare-target-compare-price]');
      const targetDetailName = root.querySelector('[data-tie-compare-target-detail-name]');
      const details = root.querySelector('[data-tie-compare-details]');
      const detailsToggle = root.querySelector('[data-tie-compare-details-toggle]');
      const detailsContent = root.querySelector('[data-tie-compare-details-content]');

      if (!menu || !search || !optionsContainer || !targetImage || !targetName) return;
      root.dataset.tieCompareReady = 'true';

      const cleanDataText = (value) => {
        if (!value) return '';
        const wrapper = document.createElement('span');
        wrapper.innerHTML = value;
        return wrapper.textContent.trim();
      };

      const currentProduct = {
        id: root.dataset.tieCurrentProductId || '',
        title: root.dataset.tieCurrentProductTitle || '',
        handle: root.dataset.tieCurrentProductHandle || '',
        url: root.dataset.tieCurrentProductUrl || '',
        image: root.dataset.tieCurrentProductImage || '',
        price: root.dataset.tieCurrentProductPrice || '',
        comparePrice: root.dataset.tieCurrentProductComparePrice || '',
        weight: root.dataset.tieCurrentProductWeight || 'Not listed',
        capacity: root.dataset.tieCurrentProductCapacity || 'Not listed',
        dimensions: root.dataset.tieCurrentProductDimensions || 'Not listed',
        strap: root.dataset.tieCurrentProductStrap || 'Not listed'
      };

      const recentProducts = readRecentProducts();
      const previousRecentProduct = recentProducts.find(
        (item) => String(item.id) !== String(currentProduct.id)
      );

      const nextRecentProducts = [currentProduct, ...recentProducts]
        .filter((item) => item.id && item.title && item.image)
        .filter((item, index, items) => (
          items.findIndex((candidate) => String(candidate.id) === String(item.id)) === index
        ))
        .slice(0, recentProductsLimit);

      writeRecentProducts(nextRecentProducts);

      const setOptionProductData = (button, product, sourceName) => {
        button.dataset.source = sourceName;
        button.dataset.productId = product.id || '';
        button.dataset.handle = product.handle || '';
        button.dataset.url = product.url || '';
        button.dataset.search = String(product.title || '').toLowerCase();
        button.dataset.title = product.title || '';
        button.dataset.image = product.image || '';
        button.dataset.price = product.price || '';
        button.dataset.comparePrice = product.comparePrice || '';
        button.dataset.weight = product.weight || 'Not listed';
        button.dataset.capacity = product.capacity || 'Not listed';
        button.dataset.dimensions = product.dimensions || 'Not listed';
        button.dataset.strap = product.strap || 'Not listed';
      };

      const renderOptionContent = (button) => {
        const image = document.createElement('img');
        image.className = 'tie-product-compare__option-image';
        image.src = button.dataset.image || '';
        image.alt = '';
        image.loading = 'lazy';

        const copy = document.createElement('span');
        copy.className = 'tie-product-compare__option-copy';

        const title = document.createElement('strong');
        title.textContent = button.dataset.title || '';

        const meta = document.createElement('span');
        meta.textContent = cleanDataText(button.dataset.price) || 'See product details';

        copy.append(title, meta);
        button.replaceChildren(image, copy);
      };

      let collectionOptions = Array.from(optionsContainer.querySelectorAll('[data-tie-compare-option]'));
      const recentOptions = [];

      recentProducts.forEach((product) => {
        if (String(product.id) === String(currentProduct.id)) return;

        const collectionIndex = collectionOptions.findIndex((button) => (
          String(button.dataset.productId || '') === String(product.id)
          || (product.handle && button.dataset.handle === product.handle)
        ));
        const button = collectionIndex >= 0
          ? collectionOptions.splice(collectionIndex, 1)[0]
          : document.createElement('button');

        button.type = 'button';
        button.className = 'tie-product-compare__option';
        button.setAttribute('role', 'option');
        button.setAttribute('data-tie-compare-option', '');
        setOptionProductData(button, product, 'recent');
        recentOptions.push(button);
      });

      collectionOptions.forEach((button) => {
        button.dataset.source = 'collection';
      });

      optionsContainer.replaceChildren();

      const appendOptionGroup = (label, sourceName, buttons) => {
        if (!buttons.length) return null;

        const group = document.createElement('div');
        group.className = 'tie-product-compare__option-group';
        group.dataset.tieCompareOptionGroup = sourceName;

        const heading = document.createElement('p');
        heading.className = 'tie-product-compare__option-heading';
        heading.textContent = label;
        group.append(heading);

        buttons.forEach((button) => {
          renderOptionContent(button);
          group.append(button);
        });

        optionsContainer.append(group);
        return group;
      };

      const optionGroups = [
        appendOptionGroup('Recently viewed', 'recent', recentOptions),
        appendOptionGroup('More from this collection', 'collection', collectionOptions)
      ].filter(Boolean);
      const options = [...recentOptions, ...collectionOptions];

      const openMenu = () => {
        menu.hidden = false;
      };

      const closeMenu = () => {
        menu.hidden = true;
      };

      search.addEventListener('focus', openMenu);
      search.addEventListener('click', openMenu);

      const updateDetails = (button) => {
        const detailMap = {
          weight: '[data-tie-compare-target-weight]',
          capacity: '[data-tie-compare-target-capacity]',
          dimensions: '[data-tie-compare-target-dimensions]',
          strap: '[data-tie-compare-target-strap]'
        };
        Object.entries(detailMap).forEach(([key, selector]) => {
          const node = root.querySelector(selector);
          if (node) node.textContent = button.dataset[key] || 'Not listed';
        });
      };

      const updateGroupVisibility = () => {
        let visibleOptions = 0;

        optionGroups.forEach((group) => {
          const groupOptions = Array.from(group.querySelectorAll('[data-tie-compare-option]'));
          const visibleGroupOptions = groupOptions.filter((button) => !button.hidden);
          group.hidden = visibleGroupOptions.length === 0;
          visibleOptions += visibleGroupOptions.length;
        });

        if (emptyState) emptyState.hidden = visibleOptions > 0;
      };

      const resetOptionFilter = () => {
        options.forEach((option) => { option.hidden = false; });
        updateGroupVisibility();
      };

      const selectOption = (button, settings = {}) => {
        targetName.textContent = button.dataset.title || '';
        if (targetDetailName) targetDetailName.textContent = button.dataset.title || '';

        targetImage.removeAttribute('srcset');
        targetImage.removeAttribute('sizes');
        targetImage.src = button.dataset.image || targetImage.src;
        targetImage.alt = `${button.dataset.title || 'Product'} comparison image`;

        if (targetPrice) targetPrice.textContent = cleanDataText(button.dataset.price) || 'Not listed';
        if (targetComparePrice) {
          const comparePrice = cleanDataText(button.dataset.comparePrice);
          targetComparePrice.textContent = comparePrice;
          targetComparePrice.hidden = !comparePrice;
        }

        options.forEach((option) => option.setAttribute('aria-selected', String(option === button)));
        updateDetails(button);

        if (settings.clearSearch !== false) search.value = '';
        resetOptionFilter();
        if (settings.closeMenu !== false) closeMenu();
      };

      options.forEach((button) => {
        button.addEventListener('click', () => selectOption(button));
      });

      search.addEventListener('input', () => {
        openMenu();
        const query = search.value.trim().toLowerCase();
        options.forEach((option) => {
          option.hidden = query !== '' && !(option.dataset.search || '').includes(query);
        });
        updateGroupVisibility();
      });

      search.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          closeMenu();
          return;
        }

        if (event.key === 'ArrowDown') {
          const firstVisibleOption = options.find((button) => !button.hidden);
          if (firstVisibleOption) {
            event.preventDefault();
            firstVisibleOption.focus();
          }
        }
      });

      document.addEventListener('click', (event) => {
        if (!picker?.contains(event.target)) closeMenu();
      });

      resetOptionFilter();

      if (previousRecentProduct) {
        const previousRecentOption = options.find((button) => (
          String(button.dataset.productId || '') === String(previousRecentProduct.id)
        ));
        if (previousRecentOption) {
          selectOption(previousRecentOption, { clearSearch: false, closeMenu: false });
        }
      }

      detailsToggle?.addEventListener('click', () => {
        const collapsed = details?.classList.toggle('is-collapsed');
        detailsToggle.setAttribute('aria-expanded', String(!collapsed));
        if (detailsContent) detailsContent.hidden = Boolean(collapsed);
      });
    });
  };

  initializeProductCompare();

  document.addEventListener('shopify:section:load', (event) => {
    initializeProductCompare(event.target);
  });
})();

/* AJAX quantity controls for the full cart page. */
(function () {
  let cartPageUpdating = false;

  const normalizeCartMoney = (root) => {
    root.querySelectorAll('.money').forEach((element) => {
      const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
      let node = walker.nextNode();

      while (node) {
        const normalized = String(node.nodeValue || '').replace(
          /(?:INR|Rs\.?|₹)\s*([\d,]+(?:\.\d{1,2})?)/gi,
          (match, amount) => {
            const rupees = Number(String(amount).replace(/,/g, ''));
            const hasPaise = Math.round(rupees * 100) % 100 !== 0;
            return `₹${rupees.toLocaleString('en-IN', {
              minimumFractionDigits: hasPaise ? 2 : 0,
              maximumFractionDigits: hasPaise ? 2 : 0,
            })}`;
          }
        );
        if (normalized !== node.nodeValue) node.nodeValue = normalized;
        node = walker.nextNode();
      }
    });
  };

  const setCartCount = (count) => {
    document.querySelectorAll('[data-tie-cart-count]').forEach((node) => {
      node.textContent = String(count);
    });
  };

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-tie-cart-page-change]');
    if (!button || cartPageUpdating) return;

    const cartSection = button.closest('[data-tie-cart-section]');
    const sectionId = cartSection?.dataset.tieCartSectionId;
    const line = Number.parseInt(button.dataset.tieCartLine || '', 10);
    const requestedQuantity = Number.parseInt(button.dataset.tieCartQuantity || '', 10);
    const quantity = Number.isFinite(requestedQuantity) ? Math.max(0, requestedQuantity) : null;

    if (!cartSection || !sectionId || !Number.isFinite(line) || quantity === null) return;

    cartPageUpdating = true;
    cartSection.setAttribute('aria-busy', 'true');
    cartSection.querySelectorAll('[data-tie-cart-page-change]').forEach((control) => {
      control.disabled = true;
    });

    try {
      const shopifyRoot = window.Shopify?.routes?.root || '/';
      const cartResponse = await fetch(`${shopifyRoot}cart/change.js`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ line, quantity })
      });

      if (!cartResponse.ok) throw new Error('Cart quantity update failed');

      const cart = await cartResponse.json();
      setCartCount(cart.item_count || 0);

      const sectionResponse = await fetch(
        `${shopifyRoot}cart?section_id=${encodeURIComponent(sectionId)}`,
        { cache: 'no-store', headers: { Accept: 'text/html' } }
      );

      if (!sectionResponse.ok) throw new Error('Cart section refresh failed');

      const sectionHtml = await sectionResponse.text();
      const sectionDocument = new DOMParser().parseFromString(sectionHtml, 'text/html');
      const nextCartSection = sectionDocument.querySelector('[data-tie-cart-section]');

      if (!nextCartSection) throw new Error('Updated cart section was not returned');

      normalizeCartMoney(nextCartSection);
      cartSection.replaceWith(nextCartSection);
    } catch (error) {
      const status = cartSection.querySelector('[data-tie-cart-page-status]');
      if (status) status.textContent = 'We could not update that quantity. Please try again.';
      cartSection.removeAttribute('aria-busy');
      cartSection.querySelectorAll('[data-tie-cart-page-change]').forEach((control) => {
        control.disabled = false;
      });
    } finally {
      cartPageUpdating = false;
    }
  });
})();

/* Keep the mobile sticky CTA and floating support controls from overlapping. */
(function () {
  const stickyBar = document.querySelector('[data-tie-product-sticky]');
  if (!stickyBar) return;

  const syncStickyHeight = () => {
    const height = Math.ceil(stickyBar.getBoundingClientRect().height);
    document.documentElement.style.setProperty('--tie-product-sticky-height', `${height}px`);
  };

  syncStickyHeight();
  window.addEventListener('resize', syncStickyHeight, { passive: true });
  window.addEventListener('orientationchange', syncStickyHeight, { passive: true });

  if ('ResizeObserver' in window) {
    const stickyObserver = new ResizeObserver(syncStickyHeight);
    stickyObserver.observe(stickyBar);
  }
})();
